// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"d636fddd9302eb9ad653","303":"75463e28adfef1dc400f","495":"578faa204bccac981269"}[chunkId] + ".js";
};